import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress,
  Pagination,
} from '@mui/material';
import ListItemProviderCreditor from './ListItemProviderCreditor';
import { fetchReport, handleError } from '../../utils/lib';
import { useSnackbar } from '../../providers/SnackBarProvider';
import { useTranslation } from 'react-i18next';

const CreditorsToleranceReport = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const snackbar = useSnackbar();

  // Always fetch fresh data when component mounts
  useEffect(() => {
    fetchCreditors(page);
  }, []);

  const fetchCreditors = async (pageNumber) => {
    setIsLoading(true);
    try {
      const response = await fetchReport('CREDITORS_TOLERANCE', pageNumber);
      setData(response);
      setPage(pageNumber);
    } catch (error) {
      handleError(error, snackbar);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event, value) => {
    fetchCreditors(value);
  };

  const handleAddPayment = () => {
    fetchCreditors(page);
  }

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data || !data.content || data.content.length === 0) {
    return (
      <Box textAlign="center" p={3}>
        <Typography variant="body1">{t('reports.noCreditorsToleranceData')}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">
          {t('reports.creditorsTolerance')} ({data.total_results || data.content.length})
        </Typography>
      </Box>

      {data.content && data.content.map((provider, index) => (
        <ListItemProviderCreditor
          key={provider.id}
          provider={provider}
          onAddPayment={handleAddPayment}
        />
      ))}

      {data.total_pages && data.total_pages > 1 && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={data.total_pages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default CreditorsToleranceReport; 